var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMessageDots = function SvgMessageDots(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77419 4.87946C3.28701 4.87946 3 5.23995 3 5.53507L3 18.211L5.58436 15.8879L20.2258 15.8879C20.7251 15.8879 21 15.5162 21 15.2619L21 5.53507C21 5.22853 20.733 4.87946 20.2258 4.87946L3.77419 4.87946ZM1 5.53507C1 3.99719 2.32589 2.87946 3.77419 2.87946L20.2258 2.87946C21.7186 2.87946 23 4.00861 23 5.53507L23 15.2619C23 16.7814 21.662 17.8879 20.2258 17.8879L6.35112 17.8879L3.28397 20.6449C2.85532 21.0344 2.29172 21.0719 1.86305 20.9072C1.42948 20.7406 1 20.3062 1 19.667L1 5.53507Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12C8.32843 12 9 11.3285 9 10.5001C9 9.67162 8.32843 9 7.5 9C6.67157 9 6 9.67162 6 10.5001C6 11.3285 6.67157 12 7.5 12Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2422 12C13.0706 12 13.7422 11.3285 13.7422 10.5001C13.7422 9.67162 13.0706 9 12.2422 9C11.4138 9 10.7422 9.67162 10.7422 10.5001C10.7422 11.3285 11.4138 12 12.2422 12Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9839 12C17.8123 12 18.4839 11.3285 18.4839 10.5001C18.4839 9.67162 17.8123 9 16.9839 9C16.1555 9 15.4839 9.67162 15.4839 10.5001C15.4839 11.3285 16.1555 12 16.9839 12Z",
    fill: "black"
  })));
};
export { SvgMessageDots as ReactComponent };
export default __webpack_public_path__ + "static/media/message-dots.304df6de.svg";